module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('index')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3784a2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/affiliate/Index.vue
// module id = 1387
// module chunks = 1